
/*
    wrapper for the BusOpsPage component for arrivals,
    passes the data context information through to
    facilitate data reloads
*/

import React, {useContext} from "react";

import DataContext from "../DataContext";

import BusOpsPage from "./BusOpsPage";

const BusOpsArrivalsPage = (props) => {
    const context = useContext(DataContext);

    console.log("Busops arrivals context", context);

    return (
        <BusOpsPage mode="NOT-DEPARTED" {...props}
            dataReload={context.dataReload}
            setReload={context.setReload}
            showExternalChange={context.showExternalChange}
        />
    )
}

export default BusOpsArrivalsPage;
